import TextField from '@material-ui/core/TextField';
import React from 'react';
import PropTypes from '../../helpers/propTypes';
import useId from '../../hooks/useId';

/**
 * Component wrapping the @material-ui/core TextField component and overriding
 * some properties to make it fit our design
 */
const defaultProps = {
  InputLabelProps: { shrink: true },
  fullWidth: true,
};

const typeProps = {
  email: {
    autoCapitalize: 'off',
    autoCorrect: 'off',
    autoComplete: 'email',
    type: 'email',
  },

  name: {
    type: 'text',
    autoCorrect: 'off',
    autoComplete: 'name',
  },
};

function CustomTextField(props) {
  const {
    value,
    error,
    onBlur,
    placeholder,
    label,
    type,
    required,
    onFocus = () => {},
  } = props;
  const handleChange = (name, e) =>
    props.onChange({
      name,
      type,
      value: e.target.value,
    });

  const inputTypeProps = typeProps[type] || {};

  const id = useId();

  return (
    <TextField
      {...defaultProps}
      {...inputTypeProps}
      error={Boolean(error)}
      helperText={error}
      id={`${type}-${id}`}
      inputProps={{
        ...inputTypeProps,
        'aria-describedby': error ? `${id}-helper-text` : '',
      }}
      label={label}
      onBlur={onBlur}
      onChange={(e) => handleChange(props.name, e)}
      onFocus={onFocus}
      placeholder={placeholder}
      required={required}
      value={value}
    />
  );
}

CustomTextField.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

CustomTextField.defaultProps = {
  error: undefined,
  onFocus: () => {},
  required: false,
};

export default CustomTextField;
